// extracted by mini-css-extract-plugin
export default {"header":"style_header__b9w2J","title":"style_title__eduPo","deleteButton":"style_deleteButton__YfUxv"};